<template>
  <fieldset
    class="admin-fieldset"
    :style="borderColor ? `border-color: ${borderColor}` : ''"
  >
    <legend
      v-if="title"
      class="admin-legend"
      :style="legendColor ? `color: ${legendColor}` : ''"
    >{{ title }}</legend>
    <slot />
  </fieldset>
</template>

<script>
export default {
  props: {
    title:       { type: String, default: '' },
    borderColor: { type: String, default: '' },  // default: red (from .admin-fieldset global CSS)
    legendColor: { type: String, default: '' },  // default: red (from .admin-legend global CSS)
  },
};
</script>
